import * as z from 'zod'

import { HOUSEHOLD_STEPS } from '@flows/configs/householdAt/constants'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_HouseholdV1GetsafeAt } from '@flows/insurance/schemas'

const household_at_zip = (params: StepConfigParams) =>
  ({
    schema: z.object({
      zip_code: BaseSchema_HouseholdV1GetsafeAt.shape.zip_code,
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_householdAt:steps.zip_code.title',
        },
      },
      {
        type: 'customComponent',
        name: 'ZipCodeInput',
        shouldTrackValues: true,
        props: {
          disabledIfValueExists: true,
        },
        inputs: [],
        outputs: ['zip_code'],
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'validateZipCode',
        options: {
          subFlow: params.subFlow,
        },
        inputs: ['zip_code'],
        outputs: ['zipValidated', 'zipValidationSubflow'],
      },
    },
    subFlow: params.subFlow,
    nextStep: HOUSEHOLD_STEPS.household_at_square_meters,
  }) as const satisfies AnyStepConfiguration

export default household_at_zip
